// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  NumberToggleWrapper,
  NumberToggleUp,
  NumberToggleInput,
  NumberToggleInputClone,
  NumberToggleDown,
  NumberContainer
} from './HorizNumberToggle.styles.js';

class HorizNumberToggle extends Component {
  static propTypes = {
    /**
     * disables the use of this component, and updates the styles
     */
    disabled: PropTypes.bool,
    /**
     * sets the maximum value
     */
    max: PropTypes.number,
    /**
     * sets the minimum value
     */
    min: PropTypes.number,
    /**
     * name attribute applied to input
     */
    name: PropTypes.string,
    /**
     *  callback function when the number value changes. Returns number value.
     */
    onChange: PropTypes.func.isRequired,
    /**
     *  number value
     */
    value: PropTypes.number,
    /**
     * Classname for styling purposes
     */
    className: PropTypes.string,

    /**
     * toggle label
     */
    label: PropTypes.string
  };

  static defaultProps = {
    disabled: false,
    max: 5000,
    min: 0,
    name: undefined,
    value: 0,
    className: '',
    label: ''
  };

  handleToggleDown = () => {
    const { disabled, min, onChange, value } = this.props;
    const newValue = value > min ? value - 1 : value;

    if (!disabled) onChange(newValue);
  };

  handleToggleUp = () => {
    const { disabled, max, onChange, value } = this.props;
    const newValue = value < max ? value + 1 : value;

    if (!disabled) onChange(newValue);
  };

  handleKeyDown = key => {
    const { keyCode } = key;

    if (keyCode === 38) {
      this.handleToggleUp();
    }
    if (keyCode === 40) {
      this.handleToggleDown();
    }
  };

  handleFocus = () => {
    document.addEventListener('keydown', this.handleKeyDown);
  };

  handleBlur = () => {
    document.removeEventListener('keydown', this.handleKeyDown);
  };

  render() {
    const { disabled, name, value, className, label } = this.props;
    return (
      <NumberContainer>
        <div>
          {label}
          <NumberToggleWrapper className={className}>
            <NumberToggleUp
              aria-label="Increase"
              className={disabled ? 'disabled' : ''}
              data-cy="nt-increase"
              type="button"
              onClick={this.handleToggleUp}
            />
            <NumberToggleInput
              data-cy="nt-input"
              type="number"
              name={name}
              value={value}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              readOnly
            />
            <NumberToggleInputClone className={disabled ? 'disabled' : ''} data-cy="nt-clone">
              {value}
            </NumberToggleInputClone>
            <NumberToggleDown
              aria-label="Decrease"
              className={disabled ? 'disabled' : ''}
              data-cy="nt-decrease"
              type="button"
              onClick={this.handleToggleDown}
            />
          </NumberToggleWrapper>
        </div>
      </NumberContainer>
    );
  }
}

export default HorizNumberToggle;
